import { render, staticRenderFns } from "./VehicleLookupSideMenu.vue?vue&type=template&id=97ffaf9c"
import script from "./VehicleLookupSideMenu.vue?vue&type=script&lang=js"
export * from "./VehicleLookupSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ffaf9c')) {
      api.createRecord('97ffaf9c', component.options)
    } else {
      api.reload('97ffaf9c', component.options)
    }
    module.hot.accept("./VehicleLookupSideMenu.vue?vue&type=template&id=97ffaf9c", function () {
      api.rerender('97ffaf9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/vehiclelookup/VehicleLookupSideMenu.vue"
export default component.exports